import { render, staticRenderFns } from "./ui-burger.vue?vue&type=template&id=bbdc37ce&scoped=true&"
import script from "./ui-burger.vue?vue&type=script&lang=js&"
export * from "./ui-burger.vue?vue&type=script&lang=js&"
import style0 from "./ui-burger.vue?vue&type=style&index=0&id=bbdc37ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdc37ce",
  null
  
)

export default component.exports